import React, { useState, useEffect } from "react";
import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyToStart() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);
  return <div data-section-id="237096" className={`fixed bottom-6 right-6 z-50 transition-all duration-500 transform ${isVisible ? "translate-y-0 opacity-100" : "translate-y-20 opacity-0 pointer-events-none"}`}>
      <Link to="tel:+14243138474">
        <div className="relative group">
          {}
          <div className="absolute -inset-1 bg-secondary rounded-full blur-md opacity-40 group-hover:opacity-70 transition duration-500 animate-pulse" />
          
          <Button size="lg" className="relative rounded-full w-16 h-16 md:w-auto md:h-14 md:px-6 bg-secondary text-secondary-foreground hover:bg-secondary/90 shadow-2xl flex items-center justify-center gap-2 border-2 border-white/20">
            <Phone className="size-6 md:size-5 animate-bounce" />
            <span className="hidden md:inline font-default font-black uppercase tracking-tighter italic">
              Call Now
            </span>
          </Button>
        </div>
      </Link>
    </div>;
}